import useSidebarRouteList from "../../hooks/useSidebarRouteList";
import useUpsellSidebarRoutes from "../../hooks/useUpsellSidebarRoutes";
import CategoryItems from "./components/CategoryItems";
import ListPrimaryContent from "./components/ListPrimaryContent";

function SidebarPrimaryContent() {
  const routeList = useSidebarRouteList();
  /** No-op when the upsell build flag is off, so the sidebar renders as it does today. */
  const sidebarList = useUpsellSidebarRoutes(routeList);

  return (
    <ListPrimaryContent>
      {sidebarList.map((list) => (
        <CategoryItems key={list.title} list={list} />
      ))}
    </ListPrimaryContent>
  );
}

export default SidebarPrimaryContent;
